module.exports = __webpack_public_path__ + "assets/img/ruijie.f73c7630.png";